import React, { useState } from "react";
import "./Login.scss";
import { Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import { FiUser } from "react-icons/fi";
import { AiOutlineLock } from "react-icons/ai";
import Loginimage from "./Loginimage.png";
// import Loginimage from "./Loginimage.svg";
import { useNavigate } from "react-router-dom";
// import axios from "axios";
import InternetChecking from "../../../components/Student/Reusablecomponents/Network";
import { useDispatch } from "react-redux";
import { userDetailsData } from "../../../components/Redux/Reducers/Logindetails";
import { LanguageOptions } from "../../../components/ReusableComponents/CommonApis";
import { SelectLanguageData } from "../../../components/Redux/Reducers/Common/Language";
import axiosInstance from "../../../components/ReusableComponents/Axios";
import { FaUser } from "react-icons/fa";
const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [LoginDetails, setLoginDetails] = useState({
    LoginId: "",
    Password: "",
  });
  const [ErrorMessage, setErrors] = useState({});
  const handleInputChange = (e) => {
    setLoginDetails({ ...LoginDetails, [e.target.name]: e.target.value });
  };
  const validationSchema = Yup.object().shape({
    LoginId: Yup.string().required("User Id is required"),
    Password: Yup.string().required("Password is required"),
  });

  const FormSubmit = async (values) => {
    const setLoginData = {
      Username: values["LoginId"],
      Password: values["Password"],
    };
    try {
      const resp = await axiosInstance.post(
        `/Login/NCLStudentLogin`,
        setLoginData
      );
      if (resp.data === 0) {
        setErrors("Invalid User Id or Password");
      } else {
        Navigation(resp.data);
        localStorage.setItem("Clearstorage", new Date());
      }
    } catch (error) {
      setErrors("Invalid User Id or Password");
    }
  };

  const Navigation = (Details) => {
    dispatch(userDetailsData({ LoginDetails: Details }));
    switch (Details.userTypeId) {
      // case 13:
      // navigate("/NCPTech");
      // break;
      case 10:
        navigate("/InstitutionAdmin");
        break;
      case 8:
        navigate("/InstitutionAdmin");
        break;
      case 7:
        navigate("/QBAdmin/QuestionBank", {
          state: {
            Tab: "SCQ",
            Topic: "0",
          },
        });
        break;
      case 4:
        setErrors("Invalid User Id or Password");
        // navigate("/Student");
        break;
      case 3:
        navigate("/TeacherDashboard");
        break;
      case 2:
        navigate("/PrincipleDashboard");
        break;
      case 1:
        if (LoginDetails?.LoginId === "nsfadmintech") {
          navigate("/NCPTech");
        } else {
          navigate("/NCLAdmin/StudentResponses");
        }
        break;
    }
  };
  // LanguageOptions(dispatch);

  const handleSubmit = () => {
    LanguageOptions(dispatch);
    const LOptions = [
      { display: "English", value: 7629 },
      { display: "Hindi", value: 7630 },
    ];
    localStorage.setItem("LanguageOptions", JSON.stringify(LOptions));
    dispatch(
      SelectLanguageData({
        SLanguage: LOptions?.[0]?.value.toString(),
      })
    );
    validationSchema
      .validate(LoginDetails, { abortEarly: false })
      .then(() => {
        FormSubmit(LoginDetails);
      })
      .catch((err) => {
        const newErrors = {};
        err.inner.forEach((error) => {
          newErrors[error.path] = error.message;
        });
        setErrors(newErrors);
      });
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <>
      <div className="container-fluid mb-3">
        <Row className="login-padding">
          <InternetChecking />
          <div className="Card Login-queries dflex p-5">
            <Col>
              <div className="Col-Image dflex alignitems JCCenter p-2">
                <img src={Loginimage} alt="Students" />
              </div>
            </Col>
            <Col className="dflex alignitems JCCenter">
              <div className="Login-details dflex flexd-column alignitems JCCenter mb-3 mt-3">
                <h4>NORTH SOUTH FOUNDATION</h4>
                <h5 style={{color:"#4D4DEF"}}><FaUser/> Admin Login</h5>
                <span className="error-message">
                  {ErrorMessage.length > 0 && ErrorMessage}
                </span>
                <div className="input-container">
                  {LoginDetails.LoginId.length === 0 && (
                    <span className="Input-icon dflex">
                      <FiUser fontSize={20} />
                    </span>
                  )}
                  <input
                    type="text"
                    name="LoginId"
                    placeholder="User Id"
                    value={LoginDetails.LoginId}
                    onKeyDown={handleKeyDown}
                    onChange={handleInputChange}
                    style={{
                      paddingLeft: LoginDetails.LoginId ? "20px" : "50px",
                    }}
                  />
                </div>
                {ErrorMessage.LoginId && (
                  <span className="error-message">{ErrorMessage.LoginId}</span>
                )}
                <div className="input-container">
                  {LoginDetails.Password.length === 0 && (
                    <span className="Input-icon dflex">
                      <AiOutlineLock fontSize={20} />
                    </span>
                  )}
                  <input
                    type="password"
                    name="Password"
                    placeholder="Password"
                    value={LoginDetails.Password}
                    onKeyDown={handleKeyDown}
                    onChange={handleInputChange}
                    style={{
                      paddingLeft: LoginDetails.Password ? "20px" : "50px",
                    }}
                  />
                </div>
                {ErrorMessage.Password && (
                  <span className="error-message">{ErrorMessage.Password}</span>
                )}
                <br />
                <button className="Buttons Poppins" onClick={handleSubmit}>
                  Login
                </button>
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </>
  );
};
export default Login;
